// 主页面 - 登录后展示
// 复用 desktop 的 AccountPanel / StockList / HeigeNotification 等组件
import { useEffect, useState } from 'react';
import { Layout, Space, Button } from 'antd';
import { SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import { useStore } from '../store/account';
import AccountPanel from '../components/AccountPanel';
import StockList from '../components/StockList';
import MarketStatusBar from '../components/MarketStatusBar';
import HeigeNotification from '../components/HeigeNotification';
import Disclaimer from '../components/Disclaimer';
import type { HeigeEvent } from '../shared/types';
import type { HeigeTriggerResult } from '../store/account';
import { clearToken, getStoredUser } from '../lib/api';

const { Header, Content, Footer } = Layout;

interface Props {
  onLogout: () => void;
}

export default function MainPage({ onLogout }: Props) {
  const { loadPool, loadAccount, refreshAccount, onHeigeEvent, loadStoreInfo } = useStore();
  const [heigeData, setHeigeData] = useState<{ event: HeigeEvent; result: HeigeTriggerResult } | null>(null);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const user = getStoredUser();

  useEffect(() => {
    loadPool();
    loadAccount();
    loadStoreInfo();
    const off = onHeigeEvent(async (data) => {
      setHeigeData(data);
      await refreshAccount();
    });
    return off;
  }, [loadPool, loadAccount, refreshAccount, onHeigeEvent, loadStoreInfo]);

  return (
    <Layout style={{ minHeight: '100vh', background: '#0d1117' }}>
      <Header className="hg-header" style={{ background: 'transparent', padding: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span className="hg-title">🏴‍☠️ 黑哥们各股跌</span>
          <span className="hg-subtitle">娱乐版 v0.1.0 · 网页版</span>
          <span className="hg-tag hg-tag-warn">仅供娱乐</span>
          {user && (
            <span style={{ color: '#8b949e', fontSize: 12, marginLeft: 16 }}>
              👤 {user.username}
            </span>
          )}
        </div>
        <Space>
          <Button
            type="text"
            size="small"
            icon={<LogoutOutlined />}
            onClick={() => {
              clearToken();
              onLogout();
            }}
            style={{ color: '#8b949e' }}
          >
            退出登录
          </Button>
        </Space>
      </Header>
      <MarketStatusBar />
      <Content style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <AccountPanel />
        <StockList />
      </Content>
      <Footer style={{ background: 'transparent', padding: 0 }}>
        <div className="hg-disclaimer">
          ⚠️ 本程序仅供娱乐，不构成任何投资建议。所有交易、账户、事件均为模拟。
          数据存储于 Cloudflare D1，多端同步。
        </div>
      </Footer>
      <HeigeNotification data={heigeData} onClose={() => setHeigeData(null)} />
      <Disclaimer />
    </Layout>
  );
}